import { NextPage } from 'next'
import { getApolloClient } from 'graphql/apolloClient'
import {
  City,
  GetRegionsServedContextQuery,
  GetRegionsServedContextQueryVariables,
  Regions,
  Resolution,
} from 'graphql/types'
import GET_REGIONS_SERVED_CONTEXT from 'graphql/queries/regionsServedContext'
import logger from 'lib/logger'
import { getRegionImageUrl } from 'lib/region'
import DefaultTemplate from 'templates/Default'
import Button from 'components/Button'
import { IconWhatsApp } from 'icons'
import styles from './RegionsServed.module.scss'
import HeaderSection from './components/Sections/Header'
import CitiesSection from './components/Sections/Cities'
import PreFooterSection from './components/Sections/PreFooter'
import * as events from './events'
import { useEffect } from 'react'

export type TProps = {
  regions: Array<Regions>
  cities?: Array<City>
}

const RegionsServed: NextPage<TProps> = ({ regions, cities }) => {
  useEffect(() => {
    events.openRegionsServedPageEvent()
  }, [])

  return (
    <DefaultTemplate
      customClass={{
        main: styles.ecPageRegionsServedContainer,
      }}
      head={{
        title: 'Cidades, bairros e regiões atendidas pela EmCasa',
        description:
          'A EmCasa tem as melhores casas e apartamentos à venda em mais de 10 cidades do Brasil. Encontre o imóvel ideal onde quiser!',
        url: '/',
        canonical: 'https://emcasa.com/regioes-atendidas',
        image: getRegionImageUrl(),
      }}
      headerProps={{
        hideShadow: true,
        TrailingElement: (
          <Button
            size="small"
            theme="green"
            element="a"
            href="https://api.whatsapp.com/send?phone=551131976638&text=Quero%20falar%20com%20a%20EmCasa%20para%20tirar%20d%C3%BAvidas"
            target="_blank"
            Icon={{
              Component: IconWhatsApp,
              color: 'white',
              title: 'Ícone: WhatsApp',
            }}
            onClick={events.headerContactButtonEvent}
          >
            Fale conosco
          </Button>
        ),
      }}
    >
      <HeaderSection />
      <CitiesSection cities={cities} />
      <PreFooterSection regions={{ buyerContextRegions: regions }} />
    </DefaultTemplate>
  )
}

export const getServerSideProps = async () => {
  const apolloClient = getApolloClient()

  const {
    data: { buyerContextRegions, cities },
  } = (await apolloClient
    .query<GetRegionsServedContextQuery, GetRegionsServedContextQueryVariables>(
      {
        query: GET_REGIONS_SERVED_CONTEXT,
        variables: {
          buyerContextRegionsCitySize: 3,
          buyerContextRegionsRegionSize: 10,
          buyerContextRegionsResolution: Resolution.Neighborhood,
        },
      },
    )
    .catch((e) => logger.capture(e))) || { data: {} }

  return {
    props: {
      regions: buyerContextRegions,
      cities,
    },
  }
}

export default RegionsServed
